import React from "react";
import { Alert, Link, Typography } from "@mui/material";

const SANDBOX_CONTACT_EMAIL = "matt@easyagility.co.uk";

const SandboxModeAlert: React.FC = () => (
  <Alert severity="warning" sx={{ mb: { xs: 2, sm: 3 }, borderRadius: 2 }}>
    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
      Sandbox mode
    </Typography>
    <Typography variant="body2" sx={{ mb: 1 }}>
      While your club is in sandbox mode, all emails — including invoices and
      member notifications — are sent only to you as the club administrator,
      not to your members.
    </Typography>
    <Typography variant="body2">
      To switch to live mode, email{" "}
      <Link href={`mailto:${SANDBOX_CONTACT_EMAIL}?subject=Switch%20club%20to%20live%20mode`}>
        Matt
      </Link>{" "}
      at{" "}
      <Link href={`mailto:${SANDBOX_CONTACT_EMAIL}?subject=Switch%20club%20to%20live%20mode`}>
        {SANDBOX_CONTACT_EMAIL}
      </Link>
      .
    </Typography>
  </Alert>
);

export default SandboxModeAlert;
